module.exports = __webpack_public_path__ + "img/box-border.a2822f43.png";